import { css } from 'styled-components';
import { TitleSize } from '.';
import { CssFromFunction } from '../../../types/types';
import { fluid } from '../../../utilities/fluid/fluid';
import { BreakPointsAndValues } from '../../../utilities/fluid/types';
import { DeviceSize, getFontMultiplier, getFontSizes } from '../bou-text/text-scale';

interface TitleStyle {
  fontSizes: BreakPointsAndValues;
  marginBottoms: BreakPointsAndValues;
  style: CssFromFunction;
}

export const bouTitleFontStyle = `
  font-family: var(--font-family__decorative);
`;

export const titleBaseStyle = css`
  ${bouTitleFontStyle};
  text-transform: uppercase;
  line-height: 103.5%;
  font-kerning: normal;
  -webkit-font-kerning: normal;
`;

function scaleTitleStyle(size: number) {
  const ret: TitleStyle = {
    fontSizes: getFontSizes(size),
    marginBottoms: [
      { width: 375, value: 15 * getFontMultiplier(size, DeviceSize.MOBILE) },
      { width: 768, value: 15 * getFontMultiplier(size, DeviceSize.TABLET) },
      { width: 1200, value: 20 * getFontMultiplier(size, DeviceSize.LG) },
      { width: 1920, value: 31 * getFontMultiplier(size, DeviceSize.XL) },
    ],
    style: titleBaseStyle,
  };
  return ret;
}

// OA: So ugly that it's hilarious, but works.
const H1Base = scaleTitleStyle(5.0);
const H1MarginBottoms = scaleTitleStyle(3.0);
const titleH1: TitleStyle = {
  ...H1Base,
  marginBottoms: H1MarginBottoms.marginBottoms,
};
const titleH2 = scaleTitleStyle(3.5);
const titleH3 = scaleTitleStyle(2.5);
const titleH4 = scaleTitleStyle(1.5);
const titleH4P = scaleTitleStyle(1.0);
const titleH5 = scaleTitleStyle(0);
const titleH6 = scaleTitleStyle(-1);
const titleH7 = scaleTitleStyle(-2);
const titleH8 = scaleTitleStyle(-2.5);

interface TitleStyleOptions {
  size: TitleSize;
  withMargin?: boolean;
  custom?: TitleStyle;
}

/**
 * @deprecated since 2.10.2023
 * Use HeadingPlatform.
 */
export function getTitleStyle({ size, withMargin, custom }: TitleStyleOptions): string {
  const { fontSizes, marginBottoms, style }: TitleStyle = (() => {
    switch (size) {
      case 'h1':
        return titleH1;
      case 'h2':
        return titleH2;
      case 'h3':
        return titleH3;
      case 'h4':
        return titleH4;
      case 'h4+':
        return titleH4P;
      case 'h5':
        return titleH5;
      case 'h6':
        return titleH6;
      case 'h7':
        return titleH7;
      case 'h8':
        return titleH8;
      case 'custom':
        if (!custom) {
          throw Error();
        }
        return custom;
      default:
        throw Error();
    }
  })();
  return `
  ${fluid('font-size', fontSizes)}
  ${withMargin ? fluid('margin-bottom', marginBottoms) : ''}
  ${style.join('')}
  `;
}
